/**
 * @generated SignedSource<<80fb23ef6bef8e7ee71c8f9c8507ea99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedOriginalPriceWithReserveStatusVariant_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OriginalListPrice_item" | "useAuctionPricing_item">;
  readonly " $fragmentType": "PdpSharedOriginalPriceWithReserveStatusVariant_item";
};
export type PdpSharedOriginalPriceWithReserveStatusVariant_item$key = {
  readonly " $data"?: PdpSharedOriginalPriceWithReserveStatusVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedOriginalPriceWithReserveStatusVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedOriginalPriceWithReserveStatusVariant_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionPricing_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OriginalListPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d267649cb4802745de17078ec1403c81";

export default node;
